export {default} from './CoachesTeamSummaryCard.connect';
